import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Lock as LockIcon, LockOpen as LockOpenIcon } from "@mui/icons-material";

const FileVisibilityToggle = ({
  isPublic = false,
  disabled = false,
  onToggle,
  titlePublic = "Set file to private",
  titlePrivate = "Set file to public",
}) => {
  const title = disabled
    ? "Visibility cannot be changed"
    : isPublic
      ? titlePublic
      : titlePrivate;

  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          size="small"
          disabled={disabled}
          onClick={(event) => {
            event.stopPropagation();
            if (!disabled) {
              onToggle?.();
            }
          }}
          sx={{
            width: 24,
            height: 24,
            color: isPublic ? "#059669" : "#64748b",
            "&:hover": {
              backgroundColor: isPublic ? "#d1fae5" : "#e2e8f0",
              color: isPublic ? "#047857" : "#334155",
            },
          }}
        >
          {isPublic ? (
            <LockOpenIcon sx={{ fontSize: "14px" }} />
          ) : (
            <LockIcon sx={{ fontSize: "14px" }} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default FileVisibilityToggle;
